import Vue from "vue";
import App from "./App.vue";
import "./utils/axios";
import router from "./router";
import store from "./store";
import "./css/index.scss";
import "./css/style.css";
// iconfont 图标库
import "./assets/iconfont/iconfont.js";
import "./assets/iconfont/iconfont.css";

import ElementUI from "element-ui";
// import 'element-ui/lib/theme-chalk/index.css';
// 引入全局组件
import "./views/flow/render/controls/index";
import "./views/flow/render/suite/index";
import "./views/flow/edit/controles/index";
import "./views/flow/edit/suite/index";
import Modal2 from "@/components/Modal2";
import nodeWrap from "@/components/flow/nodeWrap";
import VueAreaLinkage from "vue-area-linkage";
import "vue-area-linkage/dist/index.css";
import { pcaa } from "area-data";
import vueEsign from "vue-esign";

// 使用Vue.use()方法注册全局组件

Vue.component("nodeWrap", nodeWrap); //初始化组件

Vue.component("Modal2", Modal2);
Vue.use(ElementUI, {
  zIndex: 10,
  size: "small",
});

Vue.use(VueAreaLinkage);
Vue.prototype.$pcaa = pcaa;
Vue.use(vueEsign);

Vue.config.productionTip = false;
Vue.directive("focus", {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function (el) {
    // 聚焦元素
    el.querySelector("input").focus();
  },
});
Vue.directive("resize", {
  bind(el, binding) {
    // el为绑定的元素，binding为绑定给指令的对象
    let width = "",
      height = "";

    function isReize() {
      const style = document.defaultView.getComputedStyle(el);
      if (width !== style.width || height !== style.height) {
        binding.value({
          width: style.width,
          height: style.height,
        }); // 关键(这传入的是函数,所以执行此函数)
      }
      width = style.width;
      height = style.height;
    }
    el.__vueSetInterval__ = setInterval(isReize, 100);
  },
  unbind(el) {
    clearInterval(el.__vueSetInterval__);
  },
});

new Vue({
  router,
  store,
  components: {
    nodeWrap,
  },
  render: (h) => h(App),
}).$mount("#app");
